import { applyMiddleware, combineReducers, compose,createStore,} from 'redux';
import PostsReducer from './reducers/PostsReducer';
import thunk from 'redux-thunk';
import { AuthReducer } from './reducers/AuthReducer';
import todoReducers from './reducers/Reducers';
import { reducer as reduxFormReducer } from 'redux-form';
import { RestaurantReducer } from './reducers/RestaurantReducer';
import { BranchReducer } from './reducers/BranchReducer';
import { CategoryReducer } from './reducers/CategoryReducer';
import { CuisineReducer } from './reducers/CuisineReducer';
import { IngredientReducer } from './reducers/IngredientReducer';
import { ItemReducer } from './reducers/ItemReducer';
import { SettingReducer } from './reducers/SettingReducer';
import { RegistrationReducer } from './reducers/RegistrationReducer';
import { OrderReducer } from './reducers/OrderReducer';
import { InvoiceReducer } from './reducers/InvoiceReducer';


const middleware = applyMiddleware(thunk);

const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const reducers = combineReducers({
    posts: PostsReducer,
	allRestaurents: RestaurantReducer,
	allBranches: BranchReducer,
	allCategories: CategoryReducer,
	allCuisines: CuisineReducer,
	allIngredients: IngredientReducer,
	allItems: ItemReducer,
	setting: SettingReducer,
	allBusinessCategories: RegistrationReducer,
	allOrders: OrderReducer,
	allInvoices: InvoiceReducer,
    auth: AuthReducer,
		todoReducers,
	form: reduxFormReducer,	
	
});

//const store = createStore(rootReducers);

export const store = createStore(reducers,  composeEnhancers(middleware));
